import { FormTemplate } from "components/modal/templates";
import { serializeReq } from "components/shared/form";
import { bidCalculationOptionFlags } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React, { Fragment } from "react";
import { apply } from "sources/books/calculationQueues";

const config = {
    id: {
        label: "ID заявок",
        inputProps: { name: "id" },
        textarea: true,
        required: true,
        validators: [requiredField],
    },
    flags: {
        label: "Флаг",
        inputProps: { name: "flags" },
        options: bidCalculationOptionFlags.map(({ label, intValue }) => ({ label, value: intValue })),
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

class CreateRecalculateModal extends FormTemplate {
    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading, id, flags } = this.state;
        if (!isLoading) {
            if (this.isValidForm({ id, flags })) {
                this.setState({ isLoading: true, isValid: true });

                return apply(serializeReq({ bids: this.formatData() })).then((res) => {
                    if (res) {
                        if (res.failedBidIds && res.failedBidIds.length > 0) {
                            this.setState({ isLoading: false, failedBidIds: res.failedBidIds });
                        } else {
                            this.props.mergeParams && this.props.mergeParams();
                            this.close(res);
                        }
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    formatData = () => {
        const { id, flags } = this.state;
        return id
            .replace(/(\r\n|\n|\r)/gm, ",")
            .replace(/\s/, "")
            .split(",")
            .filter((item) => !!item)
            .map((item) => ({ id: item, flags }));
    };

    failedBidIds = () => {
        return (
            <div className="alert alert-danger">
                Не получилось пересчитать заявки:&nbsp;
                {this.state.failedBidIds.join(", ")}
            </div>
        );
    };

    renderBodyInner = () => {
        return (
            <Fragment>
                {this.state.failedBidIds && this.failedBidIds()}
                {this.renderField(config.id)}
                {this.renderSelect(config.flags)}
            </Fragment>
        );
    };
}

const ConfiguredModal = (props) => (
    <CreateRecalculateModal {...props} config={config} initialState={{ ...initialState, flags: 1 }} />
);

export default ConfiguredModal;
